// @unocss-include
import { useEffect, useState } from 'react';
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const handleChange = (event) => {
            setMatches(event.matches);
        };
        // Set initial state
        setMatches(mediaQueryList.matches);
        // Add listener for changes
        mediaQueryList.addEventListener('change', handleChange);
        // Cleanup listener on unmount
        return () => {
            mediaQueryList.removeEventListener('change', handleChange);
        };
    }, [query]);
    return matches;
}
//# sourceMappingURL=useMediaQuery.js.map